import { render, staticRenderFns } from "./Synopsis.vue?vue&type=template&id=eff0330e&scoped=true&"
import script from "./Synopsis.vue?vue&type=script&lang=js&"
export * from "./Synopsis.vue?vue&type=script&lang=js&"
import style0 from "./Synopsis.vue?vue&type=style&index=0&id=eff0330e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff0330e",
  null
  
)

export default component.exports